var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.765 11.47c0-.26.21-.47.47-.47h5.295c.26 0 .47.21.47.47v5.295a.47.47 0 0 1-.94 0V11.94h-4.824a.47.47 0 0 1-.47-.47ZM11 13.823A2.823 2.823 0 0 1 13.823 11h2.942a.47.47 0 0 1 0 .941h-2.942c-1.04 0-1.882.843-1.882 1.882v12.354c0 1.04.843 1.882 1.882 1.882h12.354c1.04 0 1.882-.843 1.882-1.883v-2.94a.47.47 0 0 1 .941 0v2.94A2.823 2.823 0 0 1 26.177 29H13.823A2.823 2.823 0 0 1 11 26.177V13.823Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.568 11.43a.47.47 0 0 1 0 .666l-8.53 8.53a.47.47 0 1 1-.665-.666l8.53-8.53a.47.47 0 0 1 .665 0Z",
    fill: "#fff"
  })));
};
export default SvgShare;